// A9 — ortak etkinlik planı sözlüğü (sunucu aynası: backend/event_plan_model.py). Yalnız gösterim ve form seçenekleri;
// doğrulama sunucudadır. Birim testi (test_a9_frontend_mirror_unit) iki listenin aynı kalmasını sabitler.
import {WORK_MODEL_LABELS} from './messageTemplates';
import {TECH_LABELS} from './canonicalEnums';

export {WORK_MODEL_LABELS, TECH_LABELS};
export const TECH_CODES = ['ses_sistemi', 'mikrofon', 'projeksiyon', 'ekran', 'sahne', 'isiklandirma', 'kayit', 'wifi', 'klima'];
export const AMOUNT_MODELS = ['sabit_kira', 'min_harcama', 'gorusmeye_acik'];
export const RESPONSIBILITY_LABELS = {
  venue_setup: 'Mekân hazırlığı ve oturma düzeni',
  sound_check: 'Ses ve teknik kontrol',
  equipment: 'Teknik ekipmanın temini',
  catering: 'İkram / yiyecek-içecek',
  promotion: 'Duyuru ve tanıtım',
  ticketing: 'Kayıt ve bilet takibi',
  guest_welcome: 'Katılımcı karşılama',
  security: 'Giriş düzeni ve güvenlik',
  decoration: 'Dekor ve masa düzeni',
  materials: 'Etkinlik malzemeleri',
  photo_video: 'Fotoğraf / video çekimi',
  cleanup: 'Etkinlik sonrası toplama ve temizlik',
};
export const RESPONSIBILITY_MAX = 20;
export const CUSTOM_RESPONSIBILITY_MAX = 5;
export const RESPONSIBILITY_TEXT_MAX = 120;
export const EVIDENCE_MAX = 5;
export const OWNER_LABELS = {venue: 'Mekân', organizer: 'Organizatör', shared: 'Birlikte'};
export const REVIEW_STATES = ['dispute_pending_staff_review', 'review_pending_no_response'];
export const VERIFIED_STATES = ['completed_verified', 'staff_verified'];
export const FINAL_STATES = [...VERIFIED_STATES, 'staff_rejected'];

// Kısa durum etiketi (plan başlığındaki özet) ve rol bazlı açıklama.
export const EVENT_STATE_LABELS = {
  event_pending_confirmation: 'Etkinlik sonucu bekleniyor',
  pending_second_confirmation: 'Karşı tarafın teyidi bekleniyor',
  dispute_pending_staff_review: 'Ekip inceliyor',
  review_pending_no_response: 'Ekip inceliyor',
  completed_verified: 'Doğrulandı',
  staff_verified: 'Doğrulandı',
  staff_rejected: 'Doğrulanmadı',
};

export function eventStatusText(plan, role) {
  const state = plan?.event_state, marks = plan?.confirmations || {}, mine = marks[role], other = marks[role === 'venue' ? 'organizer' : 'venue'];
  if (!state) return null;
  if (state === 'event_pending_confirmation') return plan.date_reached ? 'Etkinlik tarihi geldi. Gerçekleştiyse veya gerçekleşmediyse ayrı ayrı bildirin.' : 'Etkinlik tarihinden sonra iki taraf da sonucu ayrı ayrı bildirir.';
  if (state === 'pending_second_confirmation') return mine ? 'Gerçekleştiğini bildirdin; karşı tarafın teyidi bekleniyor. 7 gün içinde yanıt gelmezse kayıt ekip incelemesine alınır.' : other ? 'Karşı taraf etkinliğin gerçekleştiğini bildirdi; senin teyidin bekleniyor.' : 'Karşı tarafın teyidi bekleniyor.';
  if (state === 'dispute_pending_staff_review') return 'Ekip inceliyor. Taraflar aynı sonucu bildirmedi; otomatik karar verilmez.';
  if (state === 'review_pending_no_response') return 'Ekip inceliyor. İkinci teyit 7 gün içinde gelmedi; otomatik doğrulama yapılmaz.';
  if (state === 'completed_verified') return 'Doğrulandı: etkinliğin gerçekleştiği iki tarafça teyit edildi.';
  if (state === 'staff_verified') return 'Doğrulandı: ekip incelemesi sonucunda etkinlik doğrulandı.';
  if (state === 'staff_rejected') return 'Doğrulanmadı: ekip incelemesi sonucunda etkinlik doğrulanmış sayılmadı.';
  return null;
}

export const istanbulToday = (now = new Date()) => new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit'}).format(now);
